import prettyBytes from 'pretty-bytes';

import { maxFileSize } from '@qality/common-config';
import { QALITY_TEST_ISSUE_TYPE } from '@qality/common-config/src/constants';
import { IssueService, PermissionService } from '@qality/common-service';
import { CsvParseUtils } from '@qality/common-utils';

export const NO_ISSUE_TYPE = 'NO_ISSUE_TYPE';
const FIELD_REQUIRED_MESSAGE = 'This field is required.';
// eslint-disable-next-line complexity
export const uploadFilesValidator = async (values) => {
  const errors = {};

  if (!values.delimiter) {
    errors.delimiter = FIELD_REQUIRED_MESSAGE;
  }

  if (!values.encoding) {
    errors.encoding = FIELD_REQUIRED_MESSAGE;
  }

  if (!values.project) {
    errors.project = FIELD_REQUIRED_MESSAGE;
  } else {
    const projectPermissions = await PermissionService.hasProjectPermissions(
      values.project.value,
      ['CREATE_ISSUES']
    );

    if (!projectPermissions.CREATE_ISSUES) {
      errors.project = 'No permission to create issues.';
    } else {
      const allowedIssueTypes = await IssueService.getCreateIssueMetadata(
        values.project.key
      );
      const isIssueTypeInProject = allowedIssueTypes.some(
        (issueType) => issueType.name === QALITY_TEST_ISSUE_TYPE
      );
      if (!isIssueTypeInProject) {
        errors.project = NO_ISSUE_TYPE;
      }
    }
  }

  if (!values.file) {
    errors.file = FIELD_REQUIRED_MESSAGE;
  } else if (values.file.size > maxFileSize) {
    errors.file = `The CSV size is too big (${prettyBytes(values.file.size)})`;
  } else {
    const [firstPapaError] = CsvParseUtils.getParsedCSV(
      values.file.content,
      values.delimiter.value,
      values.encoding
    ).errors;
    if (firstPapaError) {
      // as rows are from 0 and this could be not readable for an enduser
      const rowNumber = firstPapaError.row + 1;
      errors.file = {
        message:
          'Uploaded file could not be recognized as a CSV file. Following error occurs:',
        errorsList: [`"${firstPapaError.message} (row ${rowNumber})"`],
      };
    }
  }
  return errors;
};
